import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import JobDescription from "../DashBoardJob/JobDescription/JobDescription";
import "./JobDescriptionModel.css";
import Dark_Blue_Btn from "../../common_components/common_btn/dark_blue_btn/Dark_Blue_Btn";
import ApplyModal from "../ApplyModel/ApplyModal";
import { Context } from "../../../utils/context";
import Cookies from "js-cookie";

const JobDescriptionModal = (props) => {
  console.log(props?.data, "prop");

  const [modalShow1, setModalShow1] = useState(false);
  const [data, setData] = useState({});
  const {
    jobSeekerData,
    fetchSeekerData,
    getData,
    imageUrl,
    NoDataAnimations,
  } = useContext(Context);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    job_id: "",
  });

  console.log(formData, "formData");

  const handleApply = async (data) => {
    await setFormData({
      name: jobSeekerData?.first_name + jobSeekerData?.last_name,
      email: jobSeekerData?.email,
      contact: jobSeekerData?.contact_no,
      job_id: props?.data?.id,
    });
    setModalShow1(true);
  };

  const handleApplyClick = () => {
    const updatedFormData = {
      name: jobSeekerData?.first_name + " " + jobSeekerData?.last_name,
      email: jobSeekerData?.email,
      contact: jobSeekerData?.contact_no,
      job_id: props?.data?.id,
    };

    setFormData(updatedFormData); // ✅ set first
    setData(props?.data); // optional
    setModalShow1(true); // ✅ then open modal
  };

  const [jobData, setJobData] = useState();
  const getJD = async () => {
    const res = await getData(`/common/job-description/${props?.data?.id}`);
    if (res?.success) {
      setJobData(res.data);
    }
  };
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);
  useEffect(() => {
    getJD();
    if (Cookies.get("echohouse_website") != null) {
      setAuthToken(Cookies.get("echohouse_website"));
      setAuthType(Cookies.get("jwtType"));
    }
  }, [props]);

  return (
    <>
      <Modal
        {...props}
        fullscreen={true}
        dialogClassName="modal-90w"
        className="jdModal"
        aria-labelledby="example-custom-modal-styling-title">
        <div className="container">
          <Modal.Header closeButton>
            {/* <Modal.Title id="contained-modal-title-vcenter">
            Modal heading
          </Modal.Title> */}
          </Modal.Header>
        </div>
        <Modal.Body>
          <JobDescription
            data={props.data}
            onJDHide={props.onHide}
            title={props.title}
            getSavedJobs={props?.getSavedJobs}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="jdFootermodal d-flex">
            <Dark_Blue_Btn btn_name="Close" onClick={props.onHide} /> &nbsp;
            {jobData?.apply === null ? (
              jobData?.apply_status && (
                <Dark_Blue_Btn btn_name="Apply" onClick={handleApplyClick} />
              )
            ) : (
              <button className="btn-apply">Applied</button>
            )}
            {/* <Button onClick={props.onHide}>Close</Button> */}
          </div>
        </Modal.Footer>
      </Modal>
      <ApplyModal
        show={modalShow1}
        formData={formData}
        setFormData={setFormData}
        onHide={() => setModalShow1(false)}
        onJDHide={props.onJDHide}
        data={data}
      />
    </>
  );
};

export default JobDescriptionModal;
